import { cn } from '@repo/utils';
import { Button } from './Button';
import type { EmptyStateProps } from '@repo/ui';

export function EmptyState({
  icon,
  title,
  heading,
  description,
  body,
  actionButton,
  action,
  variant = 'no-data',
  className,
}: EmptyStateProps) {
  const displayTitle = title || heading || '';
  const displayDesc = description || body;
  const displayAction = actionButton || action;

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 p-8 text-center',
        className,
      )}
    >
      {icon && (
        <div className="text-text-muted opacity-40 mb-1">
          {icon}
        </div>
      )}
      <p className="text-sm font-semibold text-text-secondary">{displayTitle}</p>
      {displayDesc && (
        <p className="text-xs text-text-muted max-w-xs">{displayDesc}</p>
      )}
      {displayAction && variant === 'no-data' && (
        <Button variant="primary" size="sm" onClick={displayAction.onClick} className="mt-2">
          {displayAction.label}
        </Button>
      )}
      {variant === 'filtered' && displayAction && (
        <Button variant="ghost" size="sm" onClick={displayAction.onClick} className="mt-1">
          {displayAction.label}
        </Button>
      )}
    </div>
  );
}
